import { useContext, useMemo } from 'react';
import './Privacy.scss';
import { TranslationContext } from '@app/contexts/translationContext';

export default function Privacy() {
    const { contextTranslation } = useContext(TranslationContext);

    const texts = useMemo(
        () => contextTranslation.Privacy,
        [contextTranslation],
    );

    return (
        <div className="privacy container">
            {texts.sections.map(
                (section: { title: string; texts: string[] }, i: number) => (
                    <section key={`privacy section #${i}`}>
                        <h4>{section.title}</h4>
                        {section.texts.map((paragraph: string, k: number) => (
                            <p key={`privacy section #${i} paragraph #${k}`}>
                                {paragraph}
                            </p>
                        ))}
                    </section>
                ),
            )}
        </div>
    );
}
